module.exports = __webpack_public_path__ + "img/12_maska_shit.b26ac3f.svg";